<template>
  <span>
    <span @click.stop="handleOpen">
      <slot></slot>
    </span>
    <el-dialog append-to-body :title="title" top="15vh" :visible="dialogVisible" width="400px" @close="close">
      <div style="width: 100%; display: flex; justify-content: center;margin-top:10px;">
        <div style="border:1px solid #ddd;padding:10px">
          <div style="width: 200px; height: 200px;" class="my-flex my-row-center color-info" v-if="loading">
            <i class="el-icon-loading" style="font-size: 30px;"></i>
          </div>
          <div ref="qrCodeUrl" v-show="!loading"></div>
        </div>
      </div>
      <div style="text-align:center;margin-top:10px;">打开微信，扫码支付</div>
      <div style="text-align:center;margin-top:10px; color:#999;font-size:12px;">如需发票，支付成功后联系客服，提供开票信息</div>
      <div style="text-align:center;margin-top:10px; font-size: 18px; color: red;font-weight: bold;">￥{{amount.toFixed(2)}}</div>
    </el-dialog>
  </span>
</template> 
          
<script>
// import elDragDialog from '@/directive/el-drag-dialog'

import API from '@/api/order'
import QRCode from 'qrcodejs2'

export default {
  name: '',
  directives: {},
  components: {},
  props: {
    title: {
      type: String,
      default: '微信支付'
    },
    no: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
      timeCount: 0,
      text: '',
      loading: true
    }
  },
  computed: {},
  created() {},

  methods: {
    close() {
      clearTimeout(this.timer)
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
      this.loading = true
      this.$nextTick(() => {
        this.handleSave()
      })
    },
    handleSave() {
      API.wxPayQrCode({ type: 'order', no: this.no }).then(res => {
        console.log(res)
        this.text = res.data
        this.$nextTick(() => {
          //生成二维码的方法
          this.creatQrCode()
        })
        this.timeCount = 100
        this.setTimer()
      })
    },
    creatQrCode() {
      this.$refs.qrCodeUrl.innerHTML = ''
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.text, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000', //二维码颜色
        colorLight: '#ffffff' //二维码背景色
      })
      this.loading = false
    },
    setTimer() {
      this.timer = setTimeout(() => {
        if (this.timeCount > 0) {
          API.getOne({ no: this.no })
            .then(res => {
              console.log(res)
              this.timeCount--
              if (res.data.paymentNo) {
                clearTimeout(this.timer)
                this.$msgbox.alert('支付成功', '信息', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.$emit('confirm')
                    this.close()
                  }
                })
              } else {
                this.setTimer()
              }
            })
            .catch(() => {
              this.timeCount--
              this.setTimer()
            })
        } else {
          clearTimeout(this.timer)
          this.$msgbox.alert('支付连接超时请重新支付', '信息', {
            confirmButtonText: '确定',
            callback: () => {
              this.close()
            }
          })
        }
      }, 3000)
    }
  }
}
</script>
          
    <style lang="scss" >
</style>
          